var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-collapse',{attrs:{"accordion":_vm.accordion},on:{"change":_vm.handleChange},model:{value:(_vm.activeNames),callback:function ($$v) {_vm.activeNames=$$v},expression:"activeNames"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }